import Marquee from "react-fast-marquee";
import { PROVIDERS } from "@/lib/data";
import { Car } from "lucide-react";

export default function ProviderStrip({ speed = 32, variant = "light" }) {
  const isDark = variant === "dark";
  const bg = isDark ? "bg-[#0B2545] border-white/10" : "bg-white border-line";
  const label = isDark ? "text-white/50" : "text-[#5B6472]";
  const chip = isDark
    ? "text-white/80 border border-white/15"
    : "text-[#0B2545] border border-[#E5E7EB]";
  return (
    <div className={`border-y ${bg} py-4 md:py-8`}>
      <div className="mb-3 md:mb-5 flex items-center gap-6 px-6">
        <span className={`overline ${label}`}>Compared providers</span>
        <div className={`flex-1 h-px ${isDark ? "bg-white/10" : "bg-[#E5E7EB]"}`} />
      </div>
      <Marquee gradient={false} speed={speed} pauseOnHover data-testid="provider-marquee">
        {PROVIDERS.concat(PROVIDERS).map((p, idx) => (
          <div
            key={`${p}-${idx}`}
            className={`mx-4 md:mx-6 inline-flex items-center gap-2.5 ${chip} px-4 md:px-5 py-2.5 hover:border-[#0B2545] transition-colors duration-500`}
          >
            <Car className="h-4 w-4" strokeWidth={1.5} />
            <span className="font-medium text-sm md:text-base">{p}</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
